import { createContext } from "react";
import type { Viewport } from "./roomLayout";

/**
 * ═══ LA PLACE QUE LES BANDEAUX LAISSENT À LA SALLE ═══
 *
 * L'écran de salle peut porter une image en haut et une en bas, à LEUR hauteur : c'est
 * le milieu qui s'adapte, pas elles. La feuille le sait (ses tailles sont en unités du
 * conteneur `.scene__room`, pas de la fenêtre) ; `roomLayout`, qui refait son calcul en
 * JavaScript, doit le savoir aussi — calculée sur la fenêtre, la grille des réponses
 * comptait 180 px de haut et de bas qu'elle n'avait pas, et débordait sur le bandeau.
 *
 * Mesurée par `SceneFrame` (`routes/LiveScene.tsx`). `null` hors de la salle, et tant
 * que la mesure n'est pas arrivée : on retombe alors sur la fenêtre.
 */
export const RoomBox = createContext<Viewport | null>(null);
